/* unplugin-vue-components disabled */import { render } from "./SdkInfos.vue?vue&type=template&id=96e8d25a&scoped=true"
import script from "./SdkInfos.vue?vue&type=script&lang=js"
export * from "./SdkInfos.vue?vue&type=script&lang=js"

import "./SdkInfos.vue?vue&type=style&index=0&id=96e8d25a&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96e8d25a"]])

export default __exports__